const API = process.env.REACT_APP_JOY_API_URL;

function authHeaders() {
  const token = localStorage.getItem("joy_auth_token");
  return token && token !== "TEST_SESSION" ? { Authorization: `Bearer ${token}` } : {};
}

async function req(path, opts = {}) {
  let res;
  try {
    res = await fetch(`${API}${path}`, {
      headers: { "Content-Type": "application/json", ...authHeaders(), ...(opts.headers || {}) },
      ...opts,
    });
  } catch (e) {
    throw new Error("network");
  }
  if (!res.ok) {
    const err = new Error("request_failed");
    err.status = res.status;
    throw err;
  }
  return res.json();
}

export const joyApi = {
  requestCode: (email) =>
    req("/auth/request-code", { method: "POST", body: JSON.stringify({ email }) }),
  verifyCode: (email, code) =>
    req("/auth/verify-code", { method: "POST", body: JSON.stringify({ email, code }) }),
  session: (token) =>
    req("/auth/session", { headers: token ? { Authorization: `Bearer ${token}` } : {} }),
  logout: (token) =>
    req("/auth/logout", { method: "POST", headers: token ? { Authorization: `Bearer ${token}` } : {} }),

  lessons: () => req("/lessons"),
  lesson: (id) => req(`/lessons/${id}`),
  quizzes: (id) => req(`/lessons/${id}/quizzes`),

  progress: (userId) => req(`/progress?user_id=${encodeURIComponent(userId)}`),
  completeLesson: (payload) =>
    req("/progress/complete-lesson", { method: "POST", body: JSON.stringify(payload) }),
  resetProgress: (userId) =>
    req(`/progress/reset?user_id=${encodeURIComponent(userId)}`, { method: "POST" }),

  leaderboard: (userId) => req(`/leaderboard?user_id=${encodeURIComponent(userId)}`),
  weeklyLeaderboard: (userId) => req(`/leaderboard/weekly?user_id=${encodeURIComponent(userId)}`),

  getReminder: (userId) => req(`/settings/reminder?user_id=${encodeURIComponent(userId)}`),
  setReminder: (payload) =>
    req("/settings/reminder", { method: "POST", body: JSON.stringify(payload) }),
};

export default joyApi;
